import { Grid } from '@mui/material';
import { toastConfig } from 'config';
import { toast } from 'react-toastify';
import MainCard from 'components/MainCard';
import { useEffect, useState } from 'react';
import { Col, Form, Row, Select, Spin } from 'antd';
import entity from 'assets/images/comptroller_white.svg';
import { useNavigate } from 'react-router-dom';
import ComptrollerConfirmModal from '../ComptrollerConfirmModal';
import DetailPageHeader from 'components/header/DetailPageHeader';
import FormSubmitButton from 'components/button/FormSubmitButton';
import { useAddServiceLevelMutation } from 'store/features/comptroller/comptrollerApi';
import CustomInputLabel from 'components/Label/CustomInputLabel';
import CustomSelectInput from 'components/inputs/CustomSelectInput';
import AntdValuePreview from 'components/dev/AntdValuePreview';

export const taskNatureData = [
	{ id: 1, label: 'Action', value: 'Action' },
	{ id: 2, label: 'Decision', value: 'Decision' },
];

export const timelineBasisData = [
	{ id: 1, label: '5 Days a Week', value: 5 },
	{ id: 2, label: '7 Days a Week', value: 7 },
];

export const triggeringActionData = [
	{ id: 2, label: 'Approve', value: 'Approve' },
	{ id: 3, label: 'Escalate', value: 'Escalate' },
	{ id: 1, label: 'Wait', value: 'Wait' },
];

function Create() {
	const [form] = Form.useForm();
	const navigate = useNavigate();

	const [showModal, setShowModal] = useState(false);
	const [navigateTo, setNavigateTo] = useState(null);
	const [submitData, setSubmitData] = useState(null);

	const [AddServiceLevel, { isSuccess: isAddSuccess, isLoading: isAddLoading, isError: isAddFailed }] = useAddServiceLevelMutation();

	const submitHandle = (formData) => {
		AddServiceLevel(formData);
	};

	const handleModalSubmit = (data) => {
		setSubmitData(data);
		setShowModal(true);
	};

	useEffect(() => {
		if (isAddSuccess) {
			toast.success('Success! Action completed.', toastConfig);

			if (navigateTo) {
				navigate(navigateTo);
			}
		} else if (isAddFailed) {
			setSubmitData(null);
			toast.error('Failure! Action not completed.', toastConfig);
		}
	}, [isAddSuccess, isAddFailed]);

	const onModalOkHandler = () => {
		submitHandle(submitData);

		setNavigateTo('/comptroller/service-level-agreement');
	};

	return (
		<Grid item xs={24} container rowSpacing={4.5} columnSpacing={2.75}>
			<Grid item xs={24} lg={24}>
				<DetailPageHeader title="Create Service Level Agreement" />

				<Spin spinning={isAddLoading}>
					<MainCard>
						<Form form={form} layout="vertical" autoComplete="off" requiredMark={false} onFinish={handleModalSubmit}>
							<AntdValuePreview form={form} show={false} />
							<Row gutter={[16, 0]}>
								<Col xs={24} md={8} lg={6}>
									<CustomInputLabel label="Task Nature" head={true} />
								</Col>
								<Col xs={24} sm={24} md={16} xl={18}>
									<CustomSelectInput
										form={form}
										name="taskType"
										rules={[
											{
												required: true,
												message: 'Field is required',
											},
										]}
									>
										{taskNatureData.map((value, index) => (
											<Select.Option key={index} value={value?.value}>
												{value?.label}
											</Select.Option>
										))}
									</CustomSelectInput>
								</Col>

								<Col xs={24} md={8} lg={6}>
									<CustomInputLabel label="Timeline Basis" head={true} />
								</Col>
								<Col xs={24} sm={24} md={16} xl={18}>
									<CustomSelectInput
										form={form}
										name="dayCount"
										rules={[
											{
												required: true,
												message: 'Field is Required',
											},
										]}
									>
										{timelineBasisData.map((value, index) => (
											<Select.Option key={index} value={value?.value}>
												{value?.label}
											</Select.Option>
										))}
									</CustomSelectInput>
								</Col>

								<Col xs={24} md={8} lg={6}>
									<CustomInputLabel label="SLA Triggering Action" head={true} />
								</Col>
								<Col xs={24} sm={24} md={16} xl={18}>
									<CustomSelectInput
										form={form}
										name="action"
										rules={[
											{
												required: true,
												message: 'Field is Required',
											},
										]}
									>
										{triggeringActionData.map((value, index) => (
											<Select.Option key={index} value={value?.value}>
												{value?.label}
											</Select.Option>
										))}
									</CustomSelectInput>
								</Col>

								<Col xs={24} sm={24} md={24} xl={24}>
									<FormSubmitButton />
								</Col>
							</Row>
						</Form>
					</MainCard>
				</Spin>

				{showModal && (
					<ComptrollerConfirmModal
						showModal={showModal}
						setShowModal={setShowModal}
						handleSubmit={onModalOkHandler}
						modalData={{
							head: 'Service Level Agreement',
							label: 'Do you want to submit.',
						}}
					/>
				)}
			</Grid>
		</Grid>
	);
}

export default Create;
